import checkIsFieldShownInQuery from '../../../../lib/checkIsFieldShownInQuery';

// return boolean if field should be hidden
function isEmail(value) {
  return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
    value?.toLowerCase?.(),
  );
}

function isValid(field) {
  if (field.element === 'email') {
    return isEmail(field.value);
  }

  return true;
}

export default function isFieldHidden(field = {}, isPreview = false, query = {}) {
  if (!field.hidden) return false;

  if (checkIsFieldShownInQuery(field.reference, query)) return false;

  if (field.hidden && isPreview) return true;

  if (field.hidden && !field.required) return true;

  // Address fields are always required, but their value is initialized to a default
  // object in mapFieldsToState — relying on field.value being truthy is brittle.
  // Treat hidden address fields as always hidden when toggled on.
  if (field.hidden && field.element === 'address') return true;

  if (field.hidden && field.required && field.value && isValid(field)) {
    return true;
  }

  return false;
}
